module.exports = "/img/6.d19c1a.webp";